// test1749
(1749 && 0);
